import {
  SET_ORDERS_PROP,
  SET_SCROLL_TOP,
  SET_PAYMENT_TOKEN,
  SET_DELIVERY_OPTION,
  SET_DELIVERY_ADDRESS,
  SET_DELIVERY_TIME,
  SET_PICK_UP_POINT,
  SET_POSTCODE_DATA,
  SET_LOCATION_CODE_DATA,
  STORE_PICKUP_POINT,
  STORE_DELIVERY_ADDRESS /*, STORE_ITEM_WEB*/,
  UPDATE_PAYMENT_INFO,
  SET_SELECTED_SUBSCRIPTION,
  SET_ORDER_TYPE,
  SET_LATEST_ORDER_EVENT,
  SET_GIFT_VOUCHER_DATA,
  CLEAR_GIFT_VOUCHER_DATA,
  SET_SENT_GIFT_VOUCHERS,
  SET_REDEEMED_GIFT_VOUCHER,
  CLEAR_REDEEMED_GIFT_VOUCHER,
  CLEAR_SENT_GIFT_VOUCHERS,
  SET_BILL_STATUS,
  BOOK_DELIVERY_DRIVER,
  DRIVER_COUNTDOWN,
  SET_EVENTS,
  SET_EVENT_CATEGORIES,
  SET_EVENT,
  SET_MY_EVENTS_CURRENT,
  SET_MY_EVENTS_UPCOMING,
  SET_MY_EVENTS_HISTORY,
  SET_EVENT_TICKET,
  SET_EVENT_PURCHASE,
  CLEAR_CURATED_MENU,
} from './constants';
import { isDefined } from '../../lib/utils';

let initialState = {
  history: [],
  basketUpdated: null,
  cards: [],
  orderHistory: [],
  scrollTop: 0,
  deliveryOption: null,
  deliveryAddress: null,
  deliveryTime: null,
  pickUpPoint: null,
  paymentToken: null,
  checkedCodeData: [],
  checkedLocationCodeData: [],
  storedDeliveryAddress: null,
  storedPickUpPoint: null,
  removeAddressModal: false,
  cancelOrderModal: false,
  paymentInfo: {},
  clientSecret: '',
  selectedSubscription: null,
  orderType: 'regular',
  latestOrderEvent: null,
  giftVoucherData: null,
  events: [],
  eventsPage: 1,
  eventsHasMore: false,
  eventCategories: [],
  event: null,
  myEventsCurrent: [],
  myEventsCurrentPage: 1,
  myEventsCurrentHasMore: false,
  myEventsUpcoming: [],
  myEventsUpcomingPage: 1,
  myEventsUpcomingHasMore: false,
  myEventsHistory: [],
  myEventsHistoryPage: 1,
  myEventsHistoryHasMore: false,
  eventTicket: null,
  eventPurchase: null,
  curatedMenus: [],
  curatedMenu: {},
  selectedCuratedMenuId: null
};

const setPaginatedEvents = (state, bucket, action) => {
  const { events = [], has_more = false } = action.value || {};
  const page = action.value?.page || action.page || 1;
  return {
    ...state,
    [bucket]: page > 1 ? [...(state[bucket] || []), ...events] : events,
    [`${bucket}Page`]: page,
    [`${bucket}HasMore`]: has_more,
  };
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_ORDERS_PROP:
      return {
        ...state,
        [action.key]:
          isDefined(action.merge) && action.merge
            ? { ...state[action.key], ...action.value }
            : action.value,
      };
    case SET_SCROLL_TOP:
      return { ...state, scrollTop: action.value };
    case SET_DELIVERY_OPTION:
      return { ...state, deliveryOption: action.deliveryOption };
    case SET_DELIVERY_ADDRESS:
      return { ...state, deliveryAddress: action.deliveryAddress };
    case SET_DELIVERY_TIME:
      return { ...state, deliveryTime: action.deliveryTime };
    case SET_PICK_UP_POINT:
      return { ...state, pickUpPoint: action.pickUpPoint };
    case SET_PAYMENT_TOKEN:
      return { ...state, paymentToken: action.token };
    case SET_POSTCODE_DATA:
      return { ...state, checkedCodeData: action.checkedCodeData.data };
    case STORE_DELIVERY_ADDRESS:
      return { ...state, storedDeliveryAddress: action.deliveryAddress };
    case STORE_PICKUP_POINT:
      return { ...state, storedPickUpPoint: action.pickUpPoint };
    case SET_LOCATION_CODE_DATA:
      return { ...state, checkedLocationCodeData: action.checkedLocationCodeData.data };
    case UPDATE_PAYMENT_INFO:
      return { ...state, paymentInfo: action.paymentInfo };
    case SET_SELECTED_SUBSCRIPTION:
      return { ...state, selectedSubscription: action.value };
    case SET_ORDER_TYPE:
      return { ...state, orderType: action.value };
    // case STORE_ITEM_WEB:
    // 	return { ...state, storedItemWeb: action.item }
    case SET_LATEST_ORDER_EVENT:
      return { ...state, latestOrderEvent: action.value };
    case SET_GIFT_VOUCHER_DATA:
      return { ...state, giftVoucherData: action.value };
    case CLEAR_GIFT_VOUCHER_DATA:
      return { ...state, giftVoucherData: null };
    case SET_SENT_GIFT_VOUCHERS:
      return { ...state, sentGiftVouchers: action.value };
    case SET_REDEEMED_GIFT_VOUCHER:
      return { ...state, redeemedGiftVoucher: action.value };
    case CLEAR_REDEEMED_GIFT_VOUCHER:
      return { ...state, redeemedGiftVoucher: null };
    case CLEAR_SENT_GIFT_VOUCHERS:
      return { ...state, sentGiftVouchers: [] };
    case SET_BILL_STATUS:
      return { ...state, billStatus: action.billStatus };
    case BOOK_DELIVERY_DRIVER:
      return {
        ...state,
      };
    case DRIVER_COUNTDOWN:
      return {
        ...state,
        driverCountdown: action.payload,
      };
    case SET_EVENTS:
      return setPaginatedEvents(state, 'events', action);
    case SET_EVENT_CATEGORIES:
      return { ...state, eventCategories: action.value };
    case SET_EVENT:
      return { ...state, event: action.value };
    case SET_MY_EVENTS_CURRENT:
      return setPaginatedEvents(state, 'myEventsCurrent', action);
    case SET_MY_EVENTS_UPCOMING:
      return setPaginatedEvents(state, 'myEventsUpcoming', action);
    case SET_MY_EVENTS_HISTORY:
      return setPaginatedEvents(state, 'myEventsHistory', action);
    case SET_EVENT_TICKET:
      return { ...state, eventTicket: action.value };
    case SET_EVENT_PURCHASE:
      return { ...state, eventPurchase: action.value };
    case CLEAR_CURATED_MENU:
      return { ...state, curatedMenu: {}, selectedCuratedMenuId: null };
    default:
      return state;
  }
}

export default reducer;
